import { createIcon } from "@chakra-ui/icons";

// Created from layers.svg

export const LayersIcon = createIcon({
  displayName: "Layers",
  viewBox: "0 0 18 18",
  path: (
    <g>
      <path
        d="M9 1.5L1.5 5.25L9 9L16.5 5.25L9 1.5Z"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 12.75L9 16.5L16.5 12.75"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 9L9 12.75L16.5 9"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});
